import { writable } from "svelte/store";

let stored_workspace_list = localStorage.getItem("workspace_list");

if (!stored_workspace_list) {
    localStorage.setItem("workspace_list", JSON.stringify([]));
    stored_workspace_list = localStorage.getItem("workspace_list");
}

export const workspace_list = writable(JSON.parse(stored_workspace_list));

workspace_list.subscribe(value => {
    localStorage.setItem("workspace_list", JSON.stringify(value))
});